import { createFileRoute } from "@tanstack/react-router";
import { StateLocationsHub, type StateCity } from "@/components/site/StateLocationsHub";
import beverlyHills__asset from "@/assets/restore/locations/beverly-hills.jpg.asset.json";
import newportBeach__asset from "@/assets/restore/locations/newport-beach.jpg.asset.json";
import sanDiego__asset from "@/assets/restore/locations/san-diego.jpg.asset.json";
import sanFrancisco__asset from "@/assets/restore/locations/san-francisco.jpg.asset.json";

const cities: StateCity[] = [
  {
    name: "Beverly Hills",
    address: "8383 Wilshire Blvd, Suite 800",
    img: beverlyHills__asset.url,
    mapUrl: "https://www.google.com/maps/search/?api=1&query=8383+Wilshire+Blvd+Beverly+Hills+CA",
    to: "/locations/california/beverly-hills/",
  },
  {
    name: "Newport Beach",
    address: "895 Dove Street, 3rd Floor",
    img: newportBeach__asset.url,
    mapUrl: "https://www.google.com/maps/search/?api=1&query=895+Dove+Street+Newport+Beach+CA",
    to: "/locations/california/newport-beach/",
  },
  {
    name: "San Diego",
    address: "350 10th Ave, Suite 1000",
    img: sanDiego__asset.url,
    mapUrl: "https://www.google.com/maps/search/?api=1&query=350+10th+Ave+San+Diego+CA",
    to: "/locations/california/san-diego/",
  },
  {
    name: "San Francisco",
    address: "75 Broadway, Suite 202",
    img: sanFrancisco__asset.url,
    mapUrl: "https://www.google.com/maps/search/?api=1&query=75+Broadway+San+Francisco+CA",
    to: "/locations/california/san-francisco/",
  },
];

export const Route = createFileRoute("/locations/california/")({
  head: () => ({
    meta: [
      { title: "California Hair Transplants | RESTORE® Hair" },
      {
        name: "description",
        content:
          "RESTORE® Hair in California. Find our Beverly Hills, Newport Beach, San Diego, and San Francisco locations for a free hair loss consultation.",
      },
      { property: "og:title", content: "California Hair Transplants | RESTORE® Hair" },
      {
        property: "og:description",
        content:
          "See RESTORE® Hair locations across California and book a free consultation in Beverly Hills, Newport Beach, San Diego, or San Francisco.",
      },
      { property: "og:url", content: "https://restorehair.com/locations/california/" },
    ],
    links: [{ rel: "canonical", href: "https://restorehair.com/locations/california/" }],
  }),
  component: () => <StateLocationsHub stateName="California" cities={cities} />,
});